export const CLAIM_BOOKING_OTP_RESOURCES = {
  invalidOtp: {
    id: 'ConnectBooking.otp.invalidCode',
    fallbackString: 'Invalid OTP code. Please try again.',
  },
} as const;
